(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminEngagementScores', {
                requireLogin: true,
                url: 'admin/engagementScores',
                templateUrl: 'app/admin/engagementScores/engagementScores.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator'],
                    navMarker: ['admin', 'engagementScores']
                },
                controller: 'AdminEngagementScoresCtrl'
            })
        }]);
})();